import type { ThemeConfig } from '#imports'

// Overwrite of the app layer's useThemeConfig, where we persist the theme config
// on the volunteer center profile instead of a cookie.
export const useThemeConfig = () => {
  // Load theme config from the profile
  const { currentCenterProfile } = useCurrentCenter()

  const themeConfig = useState<ThemeConfig>('themeConfig', () => currentCenterProfile.value?.themeConfig)

  // Not in used currently, we're saving the theme on the design.vue page, through the VolunteerCenter endpoint.
  // const updateThemeConfig = async (newConfig: ThemeConfig) => {
  //   if (!currentCenterProfile.value) {
  //     throw new Error('No current center profile found')
  //   }

  //   const updatedProfile = {
  //     ...currentCenterProfile.value,
  //     themeConfig: newConfig,
  //   }

  //   await $update({
  //     instance: currentCenter.value,
  //     resourceName: currentCenter.value.type,
  //     values: {
  //       profile: updatedProfile,
  //     },
  //   })

  //   themeConfig.value = newConfig
  // }

  return {
    themeConfig,
    // updateThemeConfig,
  }
}
